<mat-button-toggle>
  <mat-icon>format_align_left</mat-icon>
</mat-button-toggle>
